import { useState, useEffect } from "react";
import { Row, Col } from "antd";
import dayjs from "dayjs";

import DataTable from "../../DataTable";

interface INotesProps {
  notes: any;
}

const ClaimNoteTable: React.FC<INotesProps> = ({ notes }) => {
  const [all, setAll] = useState([]); //All Tab
  const [state, setState] = useState({
    loading: true,
    activeKey: "1",
    pagination: {
      pageSize: 15,
      position: ["bottomRight"],
      total: 0,
      current: 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const fetchAll = async (params = {}) => {
    try {
      const all = notes;

      const pagination = state.pagination;
      pagination.total = all.length;

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });

      setAll(all);
    } catch (err) {
      console.log(err);
    }
  };
  const handlePageChange = (currentPage: any) => {
    // Update the current page in state when pagination changes
    setState((prevState) => ({
      ...prevState,
      pagination: {
        ...prevState.pagination,
        current: currentPage,
      },
    }));
  };

  useEffect(() => {
    fetchAll();
  }, [notes]);

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      render: (date: Date) => dayjs(date).format("YYYY-MM-DD"),
      sorter: (a: any, b: any) => a.Date - b.Date,
    },
    {
      title: "User",
      dataIndex: ["User", "Name"],
    },
    {
      title: "Notes",
      dataIndex: "Notes",
    },
  ];

  return (
    <>
      <Row>
        <Col span={24}>
          <DataTable
            persistKey="claim-notes"
            dataSource={all}
            columns={columns}
            loading={state.loading}
            pagination={state.pagination}
            onChange={handlePageChange} // Pass the callback function to update pagination
          />
        </Col>
      </Row>
    </>
  );
};

export default ClaimNoteTable;
